import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { typeScriptData } from "../../../../Data/Miscellaneous/Editor/Editor";
import { JavaModeHeading } from "../../../../utils/Constant";

const JavaMode = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={JavaModeHeading} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={typeScriptData} language="java">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JavaMode;
